import { render, staticRenderFns } from "./Policies.vue?vue&type=template&id=72e7fc71&scoped=true"
import script from "./Policies.vue?vue&type=script&lang=js"
export * from "./Policies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e7fc71",
  null
  
)

export default component.exports